import { DEAL_TYPES } from 'resources/deal/deal.constants';
import { LISTEDKIT_TYPES } from 'resources/listedkit/listedkit.constants';

export const TASK_TYPES = {
  TASK: 'default',
  DOCUMENT_REQUEST: 'document_request',
  EMAIL_TEMPLATE: 'email_template',
};

export const TASK_STATUSES = {
  OPEN: 'open',
  COMPLETED: 'completed',
};

export const CLIENT_ASSIGNEE_TYPES = {
  SELLER: 'seller',
  BUYER: 'buyer',
};

export const AGENT_ASSIGNEE_TYPES = {
  SELLERS_AGENT: 'sellers_agent',
  BUYERS_AGENT: 'buyers_agent',
};

export const TASK_ASSIGNEE_TYPES = {
  ...CLIENT_ASSIGNEE_TYPES,
  ...AGENT_ASSIGNEE_TYPES,
  COORDINATOR: 'coordinator',
};

export const BUYER_ASSIGNEE_TYPES = {
  BUYER: TASK_ASSIGNEE_TYPES.BUYER,
  BUYERS_AGENT: TASK_ASSIGNEE_TYPES.BUYERS_AGENT,
};

export const SELLER_ASSIGNEE_TYPES = {
  SELLER: TASK_ASSIGNEE_TYPES.SELLER,
  SELLERS_AGENT: TASK_ASSIGNEE_TYPES.SELLERS_AGENT,
};

export const TASK_ASSIGNEE_TYPES_BY_DEAL_TYPE = {
  [DEAL_TYPES.SELLER]: SELLER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.SELLER_GHOST]: SELLER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.SELLER_UNDER_CONTRACT]: SELLER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.SELLER_PRE_CONTRACT]: SELLER_ASSIGNEE_TYPES,
  [DEAL_TYPES.BUYER]: BUYER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.BUYER_GHOST]: BUYER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.BUYER_UNDER_CONTRACT]: BUYER_ASSIGNEE_TYPES,
  [LISTEDKIT_TYPES.BUYER_PRE_CONTRACT]: BUYER_ASSIGNEE_TYPES,
};

export const AUTO_EMAIL_LABEL = 'auto email';
